var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Назад")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "card loading"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.show.title))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.show.image),
      expression: "!!show.image"
    }],
    staticClass: "show-img",
    attrs: {
      "src": _vm.show.image
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.show.description),
      expression: "!!show.description"
    }],
    staticClass: "card-text description",
    domProps: {
      "innerHTML": _vm._s(_vm.show.description)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.description),
      expression: "!show.description"
    }],
    staticClass: "alert alert-secondary",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                       Описание отсутствует.\n                   ")]), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Список серий")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _vm._l((_vm.seasons), function(season, index) {
    return _c('div', {
      staticClass: "card-body"
    }, [_c('h4', {
      staticClass: "card-title"
    }, [_vm._v("Сезон " + _vm._s(_vm.seasons.length - index))]), _vm._v(" "), _c('ul', {
      staticClass: "list-group"
    }, _vm._l((season), function(item) {
      return _c('li', {
        staticClass: "list-group-item list-group-item-action flex-column align-items-start"
      }, [_c('div', {
        staticClass: "d-flex w-100 justify-content-between"
      }, [_c('p', {
        staticClass: "mb-1"
      }, [_vm._v("\n                                   " + _vm._s(item.title) + "\n                                   "), _c('span', {
        staticClass: "badge badge-pill badge-info"
      }, [_vm._v("\n                                       " + _vm._s(item.shortName) + "\n                                   ")])]), _vm._v(" "), _c('small', {
        staticClass: "btn btn-sm",
        class: {
          'btn-info': !_vm.getAirDateInfo(item.airDate).status,
            'btn-light': _vm.getAirDateInfo(item.airDate).status
        }
      }, [_vm._v("\n                                   " + _vm._s(_vm.getAirDateInfo(item.airDate).text) + "\n                               ")])])])
    }))])
  })], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de43e1d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comp/Show.vue
// module id = LHXR
// module chunks = 0